import type { SubflowTemplateDTO } from '@conversed/rest/src/contracts/subflow-templates/subflow-templates.dto';
import { uniqueBy } from '@conversed/shared/src/helpers/data.helpers';
import { mainActions } from '@store/reducers/mainHandler';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useMainSelector } from '../useMainSelector';

export const useSubflowTemplates = () => {
  const {
    designer: {
      subflowTemplates: { templates, selectedTemplate, search },
    },
  } = useMainSelector();
  const dispatch = useDispatch();

  const setSubflowTemplate = useCallback(
    (data: SubflowTemplateDTO) => {
      dispatch(mainActions.setSelectedSubflowTemplate(data));
    },
    [dispatch],
  );

  const filteredSubflowTemplates = useMemo(() => {
    return templates?.filter((template: SubflowTemplateDTO) =>
      template.name?.toLowerCase().includes(search?.toLowerCase()),
    );
  }, [templates, search]);

  const subflowTemplates = useMemo(() => {
    const items = search !== '' ? filteredSubflowTemplates : templates;

    return uniqueBy(items, 'name').sort();
  }, [templates, filteredSubflowTemplates, search]);

  return {
    selectedTemplate,
    subflowTemplates,
    filteredSubflowTemplates,
    setSubflowTemplate,
  };
};
